/**
 * Politique d'OUVERTURE des exerciseurs TanoEd (côté prof).
 *
 * Le registre (`index.js`, généré par `npm run registry:gen`) contient TOUS les
 * générateurs, tous niveaux confondus ; ce module ne masque que leur
 * EXPOSITION dans le dashboard prof (cartes exerciseur, compteurs et badges du
 * panneau d'attendus, bouton « Composer N questions »). Les questions de
 * banque (exercices du collège), les sessions, l'impression, le suivi et
 * l'espace élève ne sont pas concernés.
 *
 * Un exerciseur est ouvert si son niveau a une entrée ici ET si, au choix :
 *   - la RUBRIQUE de son attendu (envoyée par le back : 'objectif' ou
 *     'automatisme', défaut objectif) figure dans `rubriques` ;
 *   - ou son numéro d'attendu figure dans `gens`, quelle que soit sa rubrique.
 *
 *
 * Décision du 2026-09-23 : les objectifs 4e du domaine Nombres (136 à 152,
 * ancien programme) sont OUVERTS après la revue du 2026-09-22 (périmètre des
 * valeurs, grille A1-A8 : sept cartes supprimées, quatre réécrites, une
 * ajoutée, harnais vert sur deux graines). Les autres objectifs 4e (153 à 200)
 * et les objectifs 3e restent fermés : ils n'ont pas été revus.
 *
 * Décision du 2026-09-23 (soir) : les objectifs 4e de divisibilité et de calcul
 * littéral (153 à 163, ancien programme) sont OUVERTS à leur tour après leur
 * revue (attendus de fin de 4e et cours du prof comme plafond, grille A1-A8 sur
 * 10 000 tirages, 57 formats devenus 50, harnais vert sur deux graines). Les
 * objectifs 4e 164 à 200 et les objectifs 3e restent fermés.
 *
 * Décision du 2026-09-23 (nuit) : les dix-huit autres objectifs 4e du
 * périmètre (données 164-165, probabilités 166, proportionnalité 171-174,
 * fonctions 175 et 177, grandeurs 178-179, translation 182, 187, 188, espace
 * 183-185, algorithmique 193) sont OUVERTS après leur revue (vagues 3 et 4 :
 * même méthode, 129 formats devenus 101, harnais vert sur deux graines avec
 * les gens qui partagent leurs modules). Restent fermés les objectifs 4e hors
 * périmètre (167 à 170, 176, 180, 181, 186, 189 à 192, 194 à 200) et les
 * objectifs 3e.
 *
 * Décision du 2026-09-24 : les trois objectifs 4e de géométrie plane 186 (cas
 * d'égalité, protocole de construction), 189 (déterminer des grandeurs) et
 * 190 (mener des raisonnements) sont OUVERTS après leur revue (chantier des
 * huit attendus de géométrie 4e : leurs anciennes cartes supprimées, 3 + 4 + 3
 * cartes neuves, solveurs et harnais verts sur deux graines). Les
 * automatismes 1086 à 1090 créés le même jour s'ouvrent avec la rubrique.
 * Restent fermés les objectifs 4e 167 à 170, 176, 180, 181, 191, 192, 194 à
 * 200 et les objectifs 3e.
 *
 * Décision du 2026-09-25 : 193 (algorithmique) est REFERMÉ, « ceux qui
 * relèvent de l'algorithme, on ne les utilise pas » (prof) ; les dix
 * objectifs 191 à 200 sont donc fermés ensemble.
 *
 * Décision du 2026-09-25 (soir) : les sept derniers objectifs 4e hors
 * algorithmique, 167 à 170 (probabilités), 176 (représenter la dépendance par
 * un graphique), 180 et 181 (agrandissement-réduction), sont OUVERTS après
 * leur revue au minimum de l'attendu de fin de 4e (cadrage du référent
 * programme, audit A1-A8 sur 10 000 tirages, réécriture, solveurs test-side,
 * harnais vert sur deux graines). Tous les objectifs 4e sont désormais
 * ouverts, sauf l'algorithmique. Les objectifs 3e restent fermés.
 *
 * Décision du 2026-09-29 (prof, avant le merge en prod) : on n'ouvre que
 * « Nombres et calculs » (136 à 163) et les objectifs traités les 24 et 25/09
 * hors « Organisation et gestion de données, fonctions » (178 à 181, 186, 187,
 * 189, 190). Sont REFERMÉS : tout le thème OGD, que le prof n'a pas encore
 * vérifié (données 164-165, probabilités 166 à 170, proportionnalité 171-174,
 * fonctions 175 à 177), la translation 182 et 188 et l'espace 183-185. Les
 * automatismes 4e restent ouverts comme avant (rubrique, et 1086 à 1090
 * nommément).
 *
 * Décision du 2026-09-29 (prof, même jour) : les objectifs 5e revus par yaVel
 * sur la spec (branche feat/campagne-5e-specifications, 22 au 28/09, fusionnée
 * dans develop) sont OUVERTS selon la liste du prof : 54 objectifs de 900 à
 * 978. Restent fermés ceux de la branche absents de sa liste : 936, 979, 981 à
 * 986 et 998 à 1001, ainsi que les objectifs 5e que la branche n'a pas revus.
 * 902 reste ouvert (décision du 2026-09-06).
 *
 * Décision du 2026-10-08 (rebase de composer-evaluation sur develop) : la
 * politique ci-dessus reste, et l'objectif 3e 201 s'ouvre seul, cible du
 * chantier (constellation des puissances). Les autres objectifs 3e restent
 * fermés ; « tu peux ouvrir pour tout » (02/10) ne valait que pour la branche.
 */
const OBJECTIFS_4E_NOMBRES_REVUS = [
    136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152,
];

const OBJECTIFS_4E_DIVISIBILITE_LITTERAL_REVUS = [
    153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163,
];

// Des vagues 3 et 4 (23/09), ne restent ouverts que les objectifs repris depuis
// (2026-09-29) : 178, 179 (grandeurs, le 25/09) et 187 (translation, le 25/09).
// Refermés : 164, 165, 166, 171, 172, 173, 174, 175, 177, 182, 183, 184, 185,
// 188 ; 193 (algorithmique) l'était depuis le 2026-09-25.
const OBJECTIFS_4E_VAGUES_3_4_REVUS = [
    178, 179, 187,
];

const OBJECTIFS_4E_GEOMETRIE_REVUS = [
    186, 189, 190,
];

// Des sept derniers objectifs 4e revus le 2026-09-25 au soir, seuls 180 et 181
// (agrandissement-réduction) sont ouverts : 167 à 170 (probabilités) et 176
// (graphique) sont du thème « Organisation et gestion de données, fonctions »,
// refermé tant que le prof ne l'a pas vérifié (2026-09-29).
const OBJECTIFS_4E_VAGUE_7_REVUS = [
    180, 181,
];

// Les cinq automatismes de géométrie créés le 2026-09-24, ouverts NOMMÉMENT :
// la rubrique vient du back, et 1086 à 1089 n'arrivaient pas en « automatisme »
// (vu à l'écran par le prof : rien sous ces attendus).
const AUTOMATISMES_4E_GEOMETRIE = [
    1086, 1087, 1088, 1089, 1090,
];

// Les objectifs 5e revus par yaVel sur la spec et retenus par le prof
// (2026-09-29) ; 903 et 951 l'étaient déjà depuis le 2026-09-06.
const OBJECTIFS_5E_REVUS_SPEC = [
    900, 903, 904, 905, 906, 907, 908, 910, 911, 912,
    914, 915, 916, 917, 918, 920, 921, 923, 924, 925,
    928, 930, 932, 933, 934, 935, 937, 940, 944, 945,
    946, 947, 948, 949, 950, 951, 952, 953, 955, 957,
    958, 960, 964, 965, 966, 968, 969, 971, 972, 973,
    974, 976, 977, 978,
];

export const OUVERTURE_EXERCISEURS = {
    '6eme': { rubriques: ['objectif', 'automatisme'], gens: [] },
    '5eme': { rubriques: ['automatisme'], gens: [902, ...OBJECTIFS_5E_REVUS_SPEC] },
    '4eme': {
        rubriques: ['automatisme'],
        gens: [
            ...OBJECTIFS_4E_NOMBRES_REVUS,
            ...OBJECTIFS_4E_DIVISIBILITE_LITTERAL_REVUS,
            ...OBJECTIFS_4E_VAGUES_3_4_REVUS,
            ...OBJECTIFS_4E_GEOMETRIE_REVUS,
            ...OBJECTIFS_4E_VAGUE_7_REVUS,
            ...AUTOMATISMES_4E_GEOMETRIE,
        ],
    },
    '3eme': { rubriques: ['automatisme'], gens: [201] },
};

export const MENTION_EXERCISEURS_A_VENIR = 'Bientôt disponible (fin septembre)';

/** '6eme' | '6' | '6ème A' | '6emeB' → '6eme' ; sinon ''. */
export const normaliserNiveau = (niveau) => {
    const m = String(niveau ?? '').match(/[3-6]/);
    return m ? `${m[0]}eme` : '';
};

/** '5eme' | '5ème B' → '5e' ; sinon ''. */
export const libelleNiveau = (niveau) => normaliserNiveau(niveau).replace('eme', 'e');

/** Le niveau a-t-il au moins quelque chose d'ouvert ? (en-tête du panneau) */
export const exerciseursOuverts = (niveau) =>
    Boolean(OUVERTURE_EXERCISEURS[normaliserNiveau(niveau)]);

/**
 * L'exerciseur de cet attendu est-il exposé ?
 * @param {string} niveau - '6eme', '5', '5ème B'…
 * @param {{rubrique?: string, attenduId?: number|string}} attendu - rubrique
 *   back ('objectif' | 'automatisme' ; absente = objectif) et numéro d'attendu
 */
export const exerciseurOuvert = (niveau, { rubrique, attenduId } = {}) => {
    const regle = OUVERTURE_EXERCISEURS[normaliserNiveau(niveau)];
    if (!regle) return false;
    if (attenduId != null && regle.gens.includes(Number(attenduId))) return true;
    return regle.rubriques.includes(rubrique === 'automatisme' ? 'automatisme' : 'objectif');
};
